import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirm-delete-message-modal',
  templateUrl: './confirm-delete-message-modal.component.html',
  styleUrls: ['./confirm-delete-message-modal.component.scss']
})
export class ConfirmDeleteMessageModalComponent implements OnInit {

  public deleteButtonDisabled: boolean = true;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.deleteButtonDisabled = false;
    }, 2000);
  }

  public delete() {
    if(!this.deleteButtonDisabled){
      this.activeModal.close(true);
    }
  }

}
